<template>
  <div>
    <van-nav-bar style="background-color: #dddddd;" :fixed="true" >
      <template #title>
        <div>
          <strong>四川省国土科学技术研究院</strong>
          <p>(廉政在线评价)</p>
        </div>
      </template>
    </van-nav-bar>
    <van-image style="top:46px;" width="100%" height="100" :src="require('../assets/img/titleimage.png')" />
    <van-form ref="validForm" @submit="onSubmit">
      <van-field
        label-width="100px"
        style="margin-top:12%"
        label-align="left"
        clearable
        v-model="formData.name"
        name="name"
        label="联系人："
        placeholder="请填写联系人姓名（必填）"
        required
        :rules="[{ required: true, message: '请填写联系人' }]"
      />
      <van-field
        label-width="100px"
        clearable
        label-align="left"
        v-model="formData.phone"
        type="number"
        maxlength="11"
        name="phone"
        label="联系电话："
        required
        placeholder="请填写联系电话（必填）"
        :rules="[{ required: true, message: '请填写联系电话' },
        { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}]"
      />
      <van-field
        class="departmentBefore"
        label-width="100px"
        label-align="left"
        readonly
        clickable
        required
        name="officeName"
        :value="formData.officeName"
        label="部门："
        placeholder="请选择部门（必填）"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择部门' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="officeLabels"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        label-width="100px"
        label-align="left"
        clearable
        required
        v-model="formData.servicePerson"
        name="servicePerson"
        label="服务人员姓名："
        placeholder="请填写服务人员姓名（必填）"
        :rules="[{ required: true, message: '请填写服务人员姓名' }]"
      />
      <van-field label-width="100px" required label-align="left" name="serviceAttitude" label="服务态度：">
        <template #input>
          <div style="width:210px">工作是否主动积极，是否专业，是否热情。</div>
          <van-radio-group v-model="formData.serviceAttitude" direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field label-width="100px" required label-align="left" name="serviceEfficiency" label="服务效率：">
        <template #input>
          <div style="width:210px">是否在约定时间内完成工作。</div>
          <van-radio-group v-model="formData.serviceEfficiency" direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field label-width="100px" required label-align="left" name="serviceQuality" label="服务质量：">
        <template #input>
          <div style="width:210px">完成的工作是否合格。</div>
          <van-radio-group v-model="formData.serviceQuality" direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field label-width="100px" required label-align="left" name="incorruptible" label="廉洁情况：">
        <template #input>
          <div style="width:210px">是否有吃拿卡要现象。</div>
          <van-radio-group v-model="formData.incorruptible" direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        label-width="100px"
        required
        label-align="left"
        v-model="formData.content"
        rows="4"
        clearable
        name="content"
        autosize
        label="意见反馈："
        type="textarea"
        maxlength="200"
        placeholder="请填写反馈意见"
        show-word-limit
        :rules="[{ required: true, message: '此选项为必填项' }]"
      />
      <div style="margin: 16px;">
        <van-button size="large" plain hairline type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { feedBacksApi, feedOfficeListApi } from "@/api/api.js";
export default {
  data() {
    return {
      formData: {
        name: "", //联系人
        phone: "", //联系电话
        officeName: "", //对应下拉框绑定的部门值
        servicePerson: "", //服务人员姓名
        serviceAttitude: "0", //服务态度
        serviceEfficiency: "0", //服务效率
        serviceQuality: "0", //服务质量
        incorruptible: "0", //廉洁情况
        content: ""
      },
      showPicker: false, //是否展示部门下拉框
      office: [],
      officeLabels:[] //部门
    };
  },
  mounted() {
    feedOfficeListApi('office').then(res => {
      this.office = res
      this.officeLabels = res.map(item=>item.label)
      // console.log(this.office)
      
    });
  },
  methods: {
    onSubmit(values) {
      let {officeName} = values
      values.officeName = this.office.find(item=>item.label===officeName).id
      feedBacksApi(values).then(res=>{
        // console.log(res)
        if(res.status===200){
          this.$toast.success('提交成功')
          this.onResetForm();
        }else {
          this.$toast.fail('提交失败请重试')
        }
        
      })
    },
    onResetForm() {
      this.formData= {
        name: "", //联系人
        phone: "", //联系电话
        officeName: "", //对应下拉框绑定的部门值
        servicePerson: "", //服务人员姓名
        serviceAttitude: "1", //服务态度
        serviceEfficiency: "1", //服务效率
        serviceQuality: "1", //服务质量
        incorruptible: "1", //廉洁情况
        content: ""
      }
    },
    onConfirm(value) {
      // console.log(value)
      this.formData.officeName = value;
      this.showPicker = false;
    }
  }
};
</script>

<style lang="less" scope>
.van-cell {
  margin-bottom: 4%;
}
.van-nav-bar {
  background-color: #f8f8f8;
}
.van-nav-bar__title {
  max-width: 73%;
  font-size: 14px;
}
.van-field__control--custom {
  flex-wrap: wrap;
}
</style>